module.exports = __webpack_public_path__ + "img/01.c984e790.jpg";